import {useEffect, useRef, useState} from "react";

import {UNLOCK_CHOICE_DECISION_TIMEOUT_MS} from "../constants/unlock_choice_timeouts";
import {useUnlockChoiceExperiment} from "./use_unlock_choice_experiment";

export interface IUnlockChoiceExperimentDecision {
    isTreatment: boolean;
    exposureTracking: Promise<void> | null;
}

interface IUseUnlockChoiceExperimentDecisionParams {
    onDecide: (decision: IUnlockChoiceExperimentDecision) => void;
}

export const useUnlockChoiceExperimentDecision = ({onDecide}: IUseUnlockChoiceExperimentDecisionParams) => {
    const {isResolved, isTreatment, trackExposure} = useUnlockChoiceExperiment({isEnabled: true});
    const [hasTimedOut, setHasTimedOut] = useState(false);
    const hasDecidedRef = useRef(false);

    useEffect(() => {
        const timeoutId = setTimeout(() => setHasTimedOut(true), UNLOCK_CHOICE_DECISION_TIMEOUT_MS);

        return () => clearTimeout(timeoutId);
    }, []);

    useEffect(() => {
        if (hasDecidedRef.current) {
            return;
        }

        if (isResolved) {
            hasDecidedRef.current = true;
            onDecide({isTreatment, exposureTracking: trackExposure()});
            return;
        }

        if (hasTimedOut) {
            hasDecidedRef.current = true;
            onDecide({isTreatment: false, exposureTracking: null});
        }
    }, [isResolved, isTreatment, hasTimedOut]);
};
import {useEffect, useRef, useState} from "react";

import {UNLOCK_CHOICE_DECISION_TIMEOUT_MS} from "../constants/unlock_choice_timeouts";
import {useUnlockChoiceExperiment} from "./use_unlock_choice_experiment";

export interface IUnlockChoiceExperimentDecision {
    isTreatment: boolean;
    exposureTracking: Promise<void> | null;
}

interface IUseUnlockChoiceExperimentDecisionParams {
    onDecide: (decision: IUnlockChoiceExperimentDecision) => void;
}

export const useUnlockChoiceExperimentDecision = ({onDecide}: IUseUnlockChoiceExperimentDecisionParams) => {
    const {isResolved, isTreatment, trackExposure} = useUnlockChoiceExperiment({isEnabled: true});
    const [hasTimedOut, setHasTimedOut] = useState(false);
    const hasDecidedRef = useRef(false);

    useEffect(() => {
        const timeoutId = setTimeout(() => setHasTimedOut(true), UNLOCK_CHOICE_DECISION_TIMEOUT_MS);

        return () => clearTimeout(timeoutId);
    }, []);

    useEffect(() => {
        if (hasDecidedRef.current) {
            return;
        }

        if (isResolved) {
            hasDecidedRef.current = true;
            onDecide({isTreatment, exposureTracking: trackExposure()});
            return;
        }

        if (hasTimedOut) {
            hasDecidedRef.current = true;
            onDecide({isTreatment: false, exposureTracking: null});
        }
    }, [isResolved, isTreatment, hasTimedOut]);
};
